import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HeroSection } from "./PatientTimelineView.styles";
export function MobileHeroSurface(props) {
    return _jsx(HeroSection, { children: props.children });
}
